import { Navigate, Outlet } from "react-router-dom";
import { useCanAccessRoute } from "../hooks/canAccessRoute";

interface IRoleAccessRoute {
  aclSection: string;
}

export default function RoleAccessRoute({
  aclSection,
}: Readonly<IRoleAccessRoute>) {
  const { canAccessRoute } = useCanAccessRoute();

  return canAccessRoute(aclSection) ? <Outlet /> : <Navigate to={`/403`} />;
}
